var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 72,
    viewBox: "0 0 160 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9467",
    "data-name": "Rectangle 9467",
    width: 160,
    height: 72,
    transform: "translate(733 737.072)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_593",
    "data-name": "Mask Group 593",
    transform: "translate(-733 -737.072)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57418",
    "data-name": "Group 57418",
    transform: "translate(778.401 741.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9463",
    "data-name": "Rectangle 9463",
    d: "M3.2,0H26a0,0,0,0,1,0,0V24a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.2A3.2,3.2,0,0,1,3.2,0Z",
    transform: "translate(5.599 4.782)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9464",
    "data-name": "Rectangle 9464",
    d: "M0,0H26a0,0,0,0,1,0,0V20.8A3.2,3.2,0,0,1,22.8,24H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(36.599 33.782)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9465",
    "data-name": "Rectangle 9465",
    d: "M0,0H24a5,5,0,0,1,5,5V27a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(36.599 1.782)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9466",
    "data-name": "Rectangle 9466",
    d: "M0,0H29a0,0,0,0,1,0,0V27a0,0,0,0,1,0,0H5a5,5,0,0,1-5-5V0A0,0,0,0,1,0,0Z",
    transform: "translate(2.599 33.782)",
    fill: "#ecf0f1",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72015",
    "data-name": "Path 72015",
    d: "M0,28.418V5A5,5,0,0,1,5,0H30",
    transform: "translate(1.599 0.782)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72016",
    "data-name": "Path 72016",
    d: "M20.441,18.848V3.316A3.362,3.362,0,0,0,17.034,0H0",
    transform: "translate(41.377 5.644)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72017",
    "data-name": "Path 72017",
    d: "M0,0V15.532a3.362,3.362,0,0,0,3.407,3.316H20.441",
    transform: "translate(6.379 37.858)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72018",
    "data-name": "Path 72018",
    d: "M30,0V23a5,5,0,0,1-5,5H-.284",
    transform: "translate(36.599 33.782)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherIcon);
export default __webpack_public_path__ + "static/media/otherIcon.6460c8641b07a2efa1b76330ff88038f.svg";
export { ForwardRef as ReactComponent };